// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   AppHeader — 신규 디자인 글로벌 헤더 (모든 features 페이지 공유)
   ======================================================================== */

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: var(--fg-bg-dark);
  font-family: var(--font-sans);
}

.app-header__left,
.app-header__right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-header__brand {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 6px;
  background: transparent;
  border: 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.app-header__brand-img {
  display: block;
  height: 32px;
  width: auto;
  object-fit: contain;
}

/* 메뉴 (아이콘 + 텍스트) */
.app-header__nav-menu {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 2px 8px 2px 4px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
}

.app-header__nav-menu:hover {
  background: var(--fg-bg-header-hover);
  color: #fff;
}

.app-header__nav-menu--active {
  background: var(--fg-bg-header-hover);
  color: var(--fg-text-menu-current);
}

/* 아이콘 버튼 (홈, 알림 등) */
.app-header__nav-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 32px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  cursor: pointer;
  transition: var(--transition-fast);
}

.app-header__nav-icon:hover,
.app-header__nav-icon--active {
  background: var(--fg-bg-header-hover);
  color: #fff;
}

.app-header__alarm-count {
  position: absolute;
  top: -2px;
  right: -3px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  background: var(--fg-anti-red);
  border-radius: 9999px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
}

.app-header__profile {
  width: 32px;
  height: 32px;
  background: var(--fg-button);
  border: 0;
  border-radius: 9999px;
  cursor: pointer;
  padding: 0;
  overflow: hidden;
}

.app-header__profile-avatar {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--fg-button), var(--fg-button-hover));
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  -webkit-user-select: none;
          user-select: none;
}

.app-header__profile--active {
  outline: 2px solid var(--fg-button-hover);
  outline-offset: 2px;
}

/* ========================================================================
   헤더 드롭다운 (알림 / 프로필)
   ======================================================================== */
.app-header__menu-anchor {
  position: relative;
  display: inline-flex;
}

.header-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  z-index: 100;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);
  font-family: var(--font-sans);
  color: var(--fg-text-basic);
  padding: 20px;
  animation: header-dropdown-fade 120ms ease-out;
}

@keyframes header-dropdown-fade {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ─── 알림 드롭다운 ─── */
.header-dropdown--alarm {
  width: 280px;
}

.header-dropdown__head {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--fg-line);
}

.header-dropdown__title {
  flex: 1 0;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.header-dropdown__head-action {
  background: transparent;
  border: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.header-dropdown__head-action:hover {
  color: var(--fg-link);
}

.header-dropdown__alarm-list {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-dropdown__alarm-item {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 10px 10px 10px 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 120ms ease;
}

.header-dropdown__alarm-item:hover {
  background: var(--fg-bg-card);
}

.header-dropdown__alarm-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--fg-text-basic);
}

.header-dropdown__alarm-body {
  flex: 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-dropdown__alarm-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--fg-text-basic);
  word-break: keep-all;
}

.header-dropdown__alarm-time {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: var(--fg-text-gray);
}

.header-dropdown__alarm-dot {
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  margin-top: 4px;
  border-radius: 50%;
  background: var(--fg-anti-red);
}

/* ─── 프로필 드롭다운 ─── */
.header-dropdown--profile {
  width: 240px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header-dropdown__profile-head {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header-dropdown__profile-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.header-dropdown__profile-row:hover .header-dropdown__profile-chevron {
  color: var(--fg-text-basic);
}

.header-dropdown__avatar {
  display: flex;
  flex-shrink: 0;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--fg-button), var(--fg-button-hover));
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  -webkit-user-select: none;
          user-select: none;
}

.header-dropdown__profile-info {
  flex: 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-dropdown__profile-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-dropdown__profile-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-dropdown__profile-divider {
  display: inline-block;
  width: 1px;
  height: 12px;
  background: var(--fg-line);
}

.header-dropdown__profile-role {
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

.header-dropdown__profile-email {
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-link);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-dropdown__profile-chevron {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: var(--fg-text-gray);
  transition: color 120ms ease;
}

.header-dropdown__token {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-dropdown__token-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
}

.header-dropdown__token-label {
  flex-shrink: 0;
  color: var(--fg-text-basic);
}

.header-dropdown__token-value {
  flex: 1 0;
  min-width: 0;
  text-align: right;
  color: var(--fg-text-basic);
}

.header-dropdown__token-value--alert {
  color: var(--fg-anti-red);
  font-weight: 600;
}

.header-dropdown__token-bar {
  height: 5px;
  width: 100%;
  background: var(--fg-line);
  border-radius: 10px;
  overflow: hidden;
}

.header-dropdown__token-bar-fill {
  height: 100%;
  background: var(--fg-text-basic);
  border-radius: 10px;
  transition: width 200ms ease;
}

.header-dropdown__token-bar-fill--alert {
  background: var(--fg-anti-red);
}

.header-dropdown__menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-dropdown__menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: background 120ms ease;
}

.header-dropdown__menu-item:hover {
  background: var(--fg-bg-card);
}

.header-dropdown__menu-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--fg-text-basic);
}

.header-dropdown__menu-label {
  flex: 1 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

.header-dropdown__menu-item--muted .header-dropdown__menu-icon,
.header-dropdown__menu-item--muted .header-dropdown__menu-label {
  color: var(--fg-text-gray);
}

/* ========================================================================
   모바일 — 햄버거 + 드로어 (≤720px)
   ======================================================================== */

/* 햄버거 버튼: 데스크톱 숨김, 모바일에서만 노출 */
.app-header__hamburger {
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 32px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  cursor: pointer;
  transition: var(--transition-fast);
}

.app-header__hamburger:hover {
  background: var(--fg-bg-header-hover);
  color: #fff;
}

/* ─── 드로어 (슬라이드 패널) — 1차 최소 버전 ─── */
.app-header__drawer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.45);
}

.app-header__drawer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: min(78vw, 300px);
  padding: 8px 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  background: var(--fg-bg-dark);
  box-shadow: 2px 0 16px rgba(0, 0, 0, 0.3);
  animation: app-drawer-in 160ms ease-out;
}

@keyframes app-drawer-in {
  from { transform: translateX(-100%); }
  to   { transform: translateX(0); }
}

/* 드로어 상단 닫기 영역 — 햄버거(좌상단)와 같은 위치/크기로 맞춤 */
.app-header__drawer-head {
  display: flex;
  align-items: center;
  height: 32px;
  margin-bottom: 8px;
  padding: 0 2px;
}

.app-header__drawer-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 32px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  cursor: pointer;
  transition: var(--transition-fast);
}

.app-header__drawer-close:hover {
  background: var(--fg-bg-header-hover);
  color: #fff;
}

.app-header__drawer-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: transparent;
  border: 0;
  border-radius: 10px;
  color: var(--fg-text-menu);
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast);
}

.app-header__drawer-item:hover {
  background: var(--fg-bg-header-hover);
  color: #fff;
}

.app-header__drawer-item--active {
  background: var(--fg-bg-header-hover);
  color: var(--fg-text-menu-current);
}

.app-header__drawer-item--cta {
  margin-top: 8px;
  background: var(--fg-button);
  color: #fff;
}

.app-header__drawer-item--cta:hover {
  background: var(--fg-button-hover);
  color: #fff;
}

/* ─── 드로어 펼침 하위메뉴 (섹션 서브내비를 글로벌 드로어로 통합) ─── */
.app-header__drawer-caret {
  margin-left: auto;
  display: inline-flex;
  color: var(--fg-text-menu);
  transition: transform var(--transition-fast);
}

.app-header__drawer-caret--open {
  transform: rotate(90deg);
}

.app-header__drawer-sub {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 2px 0 4px;
  /* 부모 라벨(아이콘 22 + gap 12 + 패딩 14)과 라인 맞춤 */
  padding-left: 46px;
}

.app-header__drawer-subitem {
  display: block;
  width: 100%;
  padding: 9px 12px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast);
}

.app-header__drawer-subitem:hover {
  background: var(--fg-bg-header-hover);
  color: #fff;
}

.app-header__drawer-subitem--active {
  color: var(--fg-text-menu-current);
  font-weight: 700;
}

@media (max-width: 720px) {
  .app-header {
    padding: 8px 14px;
  }

  /* 좌측 데스크톱 메뉴 7개 + 홈 아이콘 숨김 → 드로어로 이동 */
  .app-header__left .app-header__nav-menu,
  .app-header__left .app-header__nav-icon {
    display: none;
  }

  /* 우측 '새 에이전트 만들기' 텍스트 버튼 숨김 → 드로어 CTA 로 대체 */
  .app-header__right .app-header__nav-menu {
    display: none;
  }

  /* 햄버거 노출 */
  .app-header__hamburger {
    display: inline-flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/AppHeader.css"],"names":[],"mappings":"AAAA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,6EAA6E;EAC7E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;;6EAE6E;AAC7E;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yEAAyE;EACzE,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,SAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6EAA6E;EAC7E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,SAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;6EAE6E;;AAE7E,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,wBAAwB,EAAE;AACnC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA,uCAAuC;EACvC;;IAEE,aAAa;EACf;;EAEA,6CAA6C;EAC7C;IACE,aAAa;EACf;;EAEA,WAAW;EACX;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* ========================================================================\n   AppHeader — 신규 디자인 글로벌 헤더 (모든 features 페이지 공유)\n   ======================================================================== */\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px;\n  background: var(--fg-bg-dark);\n  font-family: var(--font-sans);\n}\n\n.app-header__left,\n.app-header__right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.app-header__brand {\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  padding: 0 6px;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  user-select: none;\n}\n\n.app-header__brand-img {\n  display: block;\n  height: 32px;\n  width: auto;\n  object-fit: contain;\n}\n\n/* 메뉴 (아이콘 + 텍스트) */\n.app-header__nav-menu {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 2px 8px 2px 4px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.app-header__nav-menu:hover {\n  background: var(--fg-bg-header-hover);\n  color: #fff;\n}\n\n.app-header__nav-menu--active {\n  background: var(--fg-bg-header-hover);\n  color: var(--fg-text-menu-current);\n}\n\n/* 아이콘 버튼 (홈, 알림 등) */\n.app-header__nav-icon {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 32px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.app-header__nav-icon:hover,\n.app-header__nav-icon--active {\n  background: var(--fg-bg-header-hover);\n  color: #fff;\n}\n\n.app-header__alarm-count {\n  position: absolute;\n  top: -2px;\n  right: -3px;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 4px;\n  background: var(--fg-anti-red);\n  border-radius: 9999px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 17px;\n  text-align: center;\n}\n\n.app-header__profile {\n  width: 32px;\n  height: 32px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 9999px;\n  cursor: pointer;\n  padding: 0;\n  overflow: hidden;\n}\n\n.app-header__profile-avatar {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--fg-button), var(--fg-button-hover));\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.app-header__profile--active {\n  outline: 2px solid var(--fg-button-hover);\n  outline-offset: 2px;\n}\n\n/* ========================================================================\n   헤더 드롭다운 (알림 / 프로필)\n   ======================================================================== */\n.app-header__menu-anchor {\n  position: relative;\n  display: inline-flex;\n}\n\n.header-dropdown {\n  position: absolute;\n  top: calc(100% + 12px);\n  right: 0;\n  z-index: 100;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);\n  font-family: var(--font-sans);\n  color: var(--fg-text-basic);\n  padding: 20px;\n  animation: header-dropdown-fade 120ms ease-out;\n}\n\n@keyframes header-dropdown-fade {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ─── 알림 드롭다운 ─── */\n.header-dropdown--alarm {\n  width: 280px;\n}\n\n.header-dropdown__head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.header-dropdown__title {\n  flex: 1 0 0;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__head-action {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.header-dropdown__head-action:hover {\n  color: var(--fg-link);\n}\n\n.header-dropdown__alarm-list {\n  list-style: none;\n  margin: 4px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-dropdown__alarm-item {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  padding: 10px 10px 10px 8px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 120ms ease;\n}\n\n.header-dropdown__alarm-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.header-dropdown__alarm-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__alarm-body {\n  flex: 1 0 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-dropdown__alarm-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--fg-text-basic);\n  word-break: keep-all;\n}\n\n.header-dropdown__alarm-time {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1;\n  color: var(--fg-text-gray);\n}\n\n.header-dropdown__alarm-dot {\n  flex-shrink: 0;\n  width: 5px;\n  height: 5px;\n  margin-top: 4px;\n  border-radius: 50%;\n  background: var(--fg-anti-red);\n}\n\n/* ─── 프로필 드롭다운 ─── */\n.header-dropdown--profile {\n  width: 240px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.header-dropdown__profile-head {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.header-dropdown__profile-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n\n.header-dropdown__profile-row:hover .header-dropdown__profile-chevron {\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__avatar {\n  display: flex;\n  flex-shrink: 0;\n  width: 25px;\n  height: 25px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--fg-button), var(--fg-button-hover));\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  user-select: none;\n}\n\n.header-dropdown__profile-info {\n  flex: 1 0 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-dropdown__profile-name-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.header-dropdown__profile-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.header-dropdown__profile-divider {\n  display: inline-block;\n  width: 1px;\n  height: 12px;\n  background: var(--fg-line);\n}\n\n.header-dropdown__profile-role {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n.header-dropdown__profile-email {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-link);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.header-dropdown__profile-chevron {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  color: var(--fg-text-gray);\n  transition: color 120ms ease;\n}\n\n.header-dropdown__token {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-dropdown__token-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.header-dropdown__token-label {\n  flex-shrink: 0;\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__token-value {\n  flex: 1 0 0;\n  min-width: 0;\n  text-align: right;\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__token-value--alert {\n  color: var(--fg-anti-red);\n  font-weight: 600;\n}\n\n.header-dropdown__token-bar {\n  height: 5px;\n  width: 100%;\n  background: var(--fg-line);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.header-dropdown__token-bar-fill {\n  height: 100%;\n  background: var(--fg-text-basic);\n  border-radius: 10px;\n  transition: width 200ms ease;\n}\n\n.header-dropdown__token-bar-fill--alert {\n  background: var(--fg-anti-red);\n}\n\n.header-dropdown__menu-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-dropdown__menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  transition: background 120ms ease;\n}\n\n.header-dropdown__menu-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.header-dropdown__menu-icon {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__menu-label {\n  flex: 1 0 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n.header-dropdown__menu-item--muted .header-dropdown__menu-icon,\n.header-dropdown__menu-item--muted .header-dropdown__menu-label {\n  color: var(--fg-text-gray);\n}\n\n/* ========================================================================\n   모바일 — 햄버거 + 드로어 (≤720px)\n   ======================================================================== */\n\n/* 햄버거 버튼: 데스크톱 숨김, 모바일에서만 노출 */\n.app-header__hamburger {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 32px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.app-header__hamburger:hover {\n  background: var(--fg-bg-header-hover);\n  color: #fff;\n}\n\n/* ─── 드로어 (슬라이드 패널) — 1차 최소 버전 ─── */\n.app-header__drawer-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.app-header__drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: min(78vw, 300px);\n  padding: 8px 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow-y: auto;\n  background: var(--fg-bg-dark);\n  box-shadow: 2px 0 16px rgba(0, 0, 0, 0.3);\n  animation: app-drawer-in 160ms ease-out;\n}\n\n@keyframes app-drawer-in {\n  from { transform: translateX(-100%); }\n  to   { transform: translateX(0); }\n}\n\n/* 드로어 상단 닫기 영역 — 햄버거(좌상단)와 같은 위치/크기로 맞춤 */\n.app-header__drawer-head {\n  display: flex;\n  align-items: center;\n  height: 32px;\n  margin-bottom: 8px;\n  padding: 0 2px;\n}\n\n.app-header__drawer-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 32px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.app-header__drawer-close:hover {\n  background: var(--fg-bg-header-hover);\n  color: #fff;\n}\n\n.app-header__drawer-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  background: transparent;\n  border: 0;\n  border-radius: 10px;\n  color: var(--fg-text-menu);\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.app-header__drawer-item:hover {\n  background: var(--fg-bg-header-hover);\n  color: #fff;\n}\n\n.app-header__drawer-item--active {\n  background: var(--fg-bg-header-hover);\n  color: var(--fg-text-menu-current);\n}\n\n.app-header__drawer-item--cta {\n  margin-top: 8px;\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.app-header__drawer-item--cta:hover {\n  background: var(--fg-button-hover);\n  color: #fff;\n}\n\n/* ─── 드로어 펼침 하위메뉴 (섹션 서브내비를 글로벌 드로어로 통합) ─── */\n.app-header__drawer-caret {\n  margin-left: auto;\n  display: inline-flex;\n  color: var(--fg-text-menu);\n  transition: transform var(--transition-fast);\n}\n\n.app-header__drawer-caret--open {\n  transform: rotate(90deg);\n}\n\n.app-header__drawer-sub {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin: 2px 0 4px;\n  /* 부모 라벨(아이콘 22 + gap 12 + 패딩 14)과 라인 맞춤 */\n  padding-left: 46px;\n}\n\n.app-header__drawer-subitem {\n  display: block;\n  width: 100%;\n  padding: 9px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.app-header__drawer-subitem:hover {\n  background: var(--fg-bg-header-hover);\n  color: #fff;\n}\n\n.app-header__drawer-subitem--active {\n  color: var(--fg-text-menu-current);\n  font-weight: 700;\n}\n\n@media (max-width: 720px) {\n  .app-header {\n    padding: 8px 14px;\n  }\n\n  /* 좌측 데스크톱 메뉴 7개 + 홈 아이콘 숨김 → 드로어로 이동 */\n  .app-header__left .app-header__nav-menu,\n  .app-header__left .app-header__nav-icon {\n    display: none;\n  }\n\n  /* 우측 '새 에이전트 만들기' 텍스트 버튼 숨김 → 드로어 CTA 로 대체 */\n  .app-header__right .app-header__nav-menu {\n    display: none;\n  }\n\n  /* 햄버거 노출 */\n  .app-header__hamburger {\n    display: inline-flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
